import Vue from 'vue';
import firebase from 'firebase';
import VueRouter from 'vue-router';
import Login from '@/views/Login.vue';
import About from '@/views/About.vue';
import Home from '@/views/Home.vue';
import VIPKalameetingSetup from '@/views/VIP/VIPKalameetingSetup.vue';
import VIPKalameetingDetails from '@/views/VIP/VIPKalameetingDetails.vue';
import FANKalameetingDetails from '@/views/FAN/FANKalameetingDetails.vue';
import VIPCameraView from '@/views/VIP/VIPCameraView.vue';
import FANCameraView from '@/views/FAN/FANCameraView.vue';
import FANFinalPage from '@/views/FAN/FANFinalPage.vue';
import store from '@/store';

Vue.use(VueRouter);

const linkActiveClass = 'my-link-active-class';

const routes = [
    {
        path: '*',
        redirect: '/'
    },
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/create-kalameeting',
        name: 'VIPKalameetingSetup',
        component: VIPKalameetingSetup,
        meta: {
            requiresAuth: true,
            requiresRole: 'VIP'
        }
    },
    {
        path: '/kalameeting/:id/manage',
        name: 'VIPKalameetingDetails',
        component: VIPKalameetingDetails,
        meta: {
            requiresAuth: true,
            requiresRole: 'VIP',
            requiresOwnership: true
        }
    },
    {
        path: '/kalameeting/:id',
        name: 'FANKalameetingDetails',
        component: FANKalameetingDetails,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/room/:id/',
        name: 'VIPCameraView',
        component: VIPCameraView,
        meta: {
            requiresAuth: true,
            requiresRole: 'VIP',
            requiresOwnership: true
        }
    },
    {
        path: '/room/:id/',
        name: 'FANCameraView',
        component: FANCameraView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/final/:id/',
        name: 'FANFinalPage',
        component: FANFinalPage,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/about',
        name: 'About',
        component: About
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    linkActiveClass
});

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some((x) => x.meta.requiresAuth);
    const requiresRole = to.matched.some((x) => x.meta.requiresRole);
    const requiresOwnership = to.matched.some((x) => x.meta.requiresOwnership);
    const isAuthenticated = firebase.auth().currentUser;
    if (requiresAuth && !isAuthenticated) {
        next('/login');
    } else if (requiresAuth && isAuthenticated) {
        if (requiresAuth && requiresRole && !requiresOwnership) {
            if (to.meta.requiresRole === store.state.userProfile.role) {
                next();
            } else {
                next('Home');
            }
        } else if (requiresAuth && requiresRole && requiresOwnership) {
            if (to.meta.requiresRole === store.state.userProfile.role
                && to.params.id === store.state.currentKalameeting
                && store.state.currentUser.uid === store.state.kalameetingDetails.owner.uid) {
                next();
            } else {
                next({
                    path: from.path,
                    replace: true
                });
            }
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
